export const config = {
  height: 300,
  rightPriceScale: {
    borderVisible: false,
  },
  timeScale: {
    borderVisible: false,
  },
}

export const themeConfig = {
  dark: {
    chart: {
      layout: {
        backgroundColor: '#1e2024',
        lineColor: '#2B2B43',
        textColor: '#D9D9D9',
      },
      watermark: {
        color: 'rgba(0, 0, 0, 0)',
      },
      grid: {
        vertLines: {
          color: '#2B2B43',
        },
        horzLines: {
          color: '#363C4E',
        },
      },
      timeScale: { fixLeftEdge: true, fixRightEdge: true },
    },
    series: {
      topColor: 'rgba(32, 226, 47, 0.56)',
      bottomColor: 'rgba(32, 226, 47, 0.04)',
      lineColor: 'rgba(32, 226, 47, 1)',
    },
    secondSeries: {
      topColor: 'rgba(33, 150, 243, 0.56)',
      bottomColor: 'rgba(33, 150, 243, 0.04)',
      lineColor: 'rgba(33, 150, 243, 1)',
    },
  },
  light: {
    chart: {
      layout: {
        backgroundColor: '#FFFFFF',
        lineColor: '#2B2B43',
        textColor: '#191919',
      },
      watermark: {
        color: 'rgba(0, 0, 0, 0)',
      },
      grid: {
        vertLines: {
          visible: false,
        },
        horzLines: {
          color: '#f0f3fa',
        },
      },
    },
    series: {
      topColor: 'rgba(0, 140, 240, 0.56)',
      bottomColor: 'rgba(0, 140, 240, 0.04)',
      lineColor: 'rgba(0, 140, 240, 1)',
    },
    secondSeries: {
      topColor: 'rgba(117, 0, 235, 0.56)',
      bottomColor: 'rgba(117, 0, 235, 0.04)',
      lineColor: 'rgba(117, 0, 235, 1)',
    },
  },
}
